import { Grid, Typography } from "@material-ui/core";
import { useStyles } from "../about-me-mentor.styles";
interface AchievementsMentorProps {
  data?: string[];
}
function AchievementsMentor({ data }: AchievementsMentorProps) {
  const classes = useStyles();
  return (
    <Grid container spacing={3}>
      <Grid item container spacing={1}>
        <Typography className={classes.title}>Achievements</Typography>
      </Grid>
      <Grid item container spacing={1} justifyContent="center">
        {data && data.length > 0 ? (
          <ul>
            {data.map((achievement, index) => {
              return (
                <li key={index} data-testid={achievement}>
                  {achievement}
                </li>
              );
            })}
          </ul>
        ) : (
          <Grid item spacing={1} style={{ marginLeft: "-15px" }}>
            <Typography>No achievements found.</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
export default AchievementsMentor;
